import { render, staticRenderFns } from "./SideMenuShop.vue?vue&type=template&id=1deaa550&scoped=true&lang=pug&"
import script from "./SideMenuShop.vue?vue&type=script&lang=js&"
export * from "./SideMenuShop.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuShop.vue?vue&type=style&index=0&id=1deaa550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deaa550",
  null
  
)

export default component.exports